/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] - [2026] Narbase Technologies
 * All Rights Reserved.
 * Created by Omnia
 * On: 13/Oct/2026.
 */
@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.ridepromocode

import com.narbase.letsgo.dto.core.KmmLong
import com.narbase.letsgo.dto.core.DateTimeDto
import com.narbase.letsgo.web.dto.currency.CurrencyDto

class LocationLockDto(
    val lat: Double,
    val lng: Double,
    val radiusInKm: Double
)

class AdminRidePromoCodeDto(
    val id: KmmLong?,
    val code: String,
    val isPercentage: Boolean,
    val percentage: Double?,
    val amount: Double?,
    val limitPerTrip: Double,
    val expiration: DateTimeDto,
    val tripsPerUser: Int,
    val maxUsersCount: Int,
    val actualUsersCount: Int,   // read-only: ignored by the server on upsert
    val budget: Double,
    val spending: Double,        // read-only: ignored by the server on upsert
    val pickupLock: LocationLockDto?,
    val destLock: LocationLockDto?,
    val currencyId: Int?,
    val startDateLock: DateTimeDto?,
    val endDateLock: DateTimeDto?,
    val isAppOnly: Boolean,
    val autoAssignOnRegistration: Boolean,
    val promoAdditionalInfo: PromoAdditionalInfoDto?
)

class ExtendedRidePromoCodeDto(
    val ridePromoCode: AdminRidePromoCodeDto,
    val currency: CurrencyDto?
)

data class PromoAdditionalInfoDto(
    val notificationTitle: String?,
    val notificationBody: String?
)